import BaseModule from './BaseModule'

class CountableContent extends BaseModule {
	constructor(o) {
		super(o);

		// A conditional field that is hidden again must drop its constraint,
		// otherwise submit is blocked with no visible field to correct.
		// Registered through BaseModule so `destroy()` unbinds it when barba
		// tears the page down on an SPA transition.
		if (this.el.form) {
			this.addEvents([$(this.el.form), 'change', 'enforceMin'])
		}

		this.enable();
	}

	enable() {
		super.enable()

		this.el.addEventListener('keyup', function () {
			setTimeout(this.handleChange.bind(this), 250)
		}.bind(this))

		this.createCounterElement()

		this.enforceMin()
		this.updateCounter()
	}

	current(unit) {
		const content = this.el.value

		if (content === undefined) {
			return 0
		}

		switch (unit) {
			case 'chars':
				return content.length
			case 'words':
				return this.countWords(content)
			default:
		}
	}

	countWords(count) {
		const words = count.match(/\S+/g)

		if (words === null) {
			return 0
		}

		return words.length
	}

	handleChange() {
		this.enforceMax()
		this.enforceMin()
		this.updateCounter()
	}

	updateCounter() {
		const unit = this.$el.data('countable-unit')
		this.$counter_element
			.text(this.current(unit) + ' / ' + this.$el.data('countable-max') + ' ' + unit)
			.toggleClass('text-danger', this.isBelowMin())
			.toggleClass('text-muted', !this.isBelowMin())
	}

	createCounterElement() {
		this.$counter_element = $('<p>')
			.addClass('text-right')
			.addClass('text-muted')
		this.$el.after(this.$counter_element)
	}

	limitWords(content, max) {
		return content.split(/\s+/, max).join(' ');
	}

	isBelowMin() {
		const min = this.$el.data('countable-min')

		if (min === undefined) {
			return false
		}

		const current = this.current(this.$el.data('countable-unit'))

		// Mirrors the server, where the length rule skips empty values and
		// `required` handles them instead.
		if (current === 0) {
			return false
		}

		return current < min
	}

	enforceMin() {
		if (typeof this.el.setCustomValidity !== 'function') {
			return
		}

		const below = this.isBelowMin() && this.el.offsetParent !== null

		this.el.setCustomValidity(
			below
				? 'Please use at least ' + this.$el.data('countable-min') + ' ' + this.$el.data('countable-unit') + '.'
				: ''
		)
	}

	enforceMax() {
		let content = this.el.value
		const max = this.$el.data('countable-max')
		const unit = this.$el.data('countable-unit')
		const current = this.current(unit)
		if (current > max) {
			switch (unit) {
				case 'words':
					content = this.limitWords(content, max)
					break;
				case 'chars':
				default:
					content = content.substring(0, max)
					break;
			}
			this.el.value = content
		}
	}
}

export default CountableContent
